/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import {
	ClientGroupExtendedAccessibilityEnum,
	ClientGroupExtendedContentVisibilityEnum
} from '@DigitaleDoerfer/digitale-doerfer-api';

interface Props {
	groupType: ClientGroupExtendedAccessibilityEnum;
	groupVisibility: ClientGroupExtendedContentVisibilityEnum | null;
	groupContentVisibility: boolean;
	handleInputChange: (event: React.ChangeEvent<{ value: string }>) => void;
}

const GroupVisibilityView = (props: Props): JSX.Element => {
	const { groupType, groupVisibility, groupContentVisibility, handleInputChange } = props;
	return (
		<FormControl variant="standard">
			<FormLabel>Sichtbarkeit der Gruppe </FormLabel>
			<RadioGroup id="groupVisibility" name="groupVisibility" value={groupVisibility} onChange={handleInputChange} row>
				<FormControlLabel value={ClientGroupExtendedContentVisibilityEnum.Anyone} control={<Radio />} label="Global" />
				<FormControlLabel
					value={ClientGroupExtendedContentVisibilityEnum.SameHomeArea}
					control={<Radio />}
					label="Heimatgemeinde"
				/>
				<FormControlLabel
					value={ClientGroupExtendedContentVisibilityEnum.Members}
					control={<Radio />}
					label="nur Mitglieder"
					disabled={groupType === ClientGroupExtendedAccessibilityEnum.Public || groupContentVisibility}
				/>
			</RadioGroup>
		</FormControl>
	);
};

export default GroupVisibilityView;
